<template>
  <main class="mt-5">
    <div class="container pb-5 nobgMob">
      <h1 class="f-98 ff-2 mb-0">
        Fiat in / out
      </h1>
      <div class="row">
        <div class="col-lg-9 f-18 mt-4 color-2">
          Decentralized escrow is possible only in crypto and you first need to convert your fiat money (such as USD, EUR) to cryptocurrencies. We recommend using stablecoins pegged to fiat currencies in order to protect against volatility common for other cryptocurrencies. One popular stablecoin is <a href="https://coinmarketcap.com/currencies/usd-coin/" target="_blank" rel="noopener">USDC</a>, which is supported by Coinbase and pegged to USD.
        </div>
      </div>

      <div class="row">
        <h2 class="col-lg-9 f-52 ff-2 mt-5">
          Getting in
        </h2>
      </div>
      <div class="row">
        <div class="col-lg-9 mb-3">
          <img style="width: 100%; padding-right: 15px;" src="../assets/image/getting_in.png" alt="getting in" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-9 f-18 mt-2 color-2">
          1. To convert your fiat to USDC, use any cryptocurrency exchange. Depending on your jurisdiction, different exchanges might be available to you. Popular choices are 
          <a href="https://coinbase.com/" target="_blank" rel="noopener nofollow">Coinbase</a>, 
          <a href="https://binance.com/" target="_blank" rel="noopener nofollow">Binance</a>, 
          <a href="https://kraken.com/" target="_blank" rel="noopener nofollow">Kraken</a>, 
          <a href="https://crypto.com/" target="_blank" rel="noopener nofollow">Crypto.com</a>, 
          and many others.
        </div>
        <div class="col-lg-9 f-18 mt-4 color-2">
          You need to deposit USD (or another currency) to the exchange, then buy the necessary amount of USDC on the exchange. You also need to acquire a small (about $50 worth) amount of ETH since ETH is required to pay for transaction fees on Ethereum.
        </div>
        <div class="col-lg-9 f-18 mt-4 color-2">
          As an alternative to cryptocurrency exchanges, you can also use an OTC desk. A good list of OTC desks working with crypto is available <a href="https://dezentralizedfinance.com/crypto-otc-trading/" target="_blank" rel="noopener nofollow">here</a>. They offer more personalized service that might be more suitable for newcomers, however they work only with large amounts with typical minimums at $50K-100K.
        </div>
        <div class="col-lg-9 f-18 mt-4 color-2">
          2. Set up your MetaMask wallet. See the guide <router-link to="/obyte-usdc-guide">How to get USDC into Obyte wallet to pay the contract</router-link>.
        </div>
        <div class="col-lg-9 f-18 mt-4 color-2">
          3. Withdraw both USDC and ETH from the exchange (or OTC provider) to your MetaMask wallet.
        </div>
        <div class="col-lg-9 f-18 mt-4 color-2">
          4. Download and set up your <a href="https://obyte.org/#download" target="_blank" rel="noopener">Obyte wallet</a>. See the first steps of the <router-link to="/guide">User guide</router-link> for details.
        </div>
        <div class="col-lg-9 f-18 mt-4 color-2">
          5. Transfer your USDC from MetaMask to your Obyte wallet using <a href="https://counterstake.org" target="_blank" rel="noopener">Counterstake Bridge</a>. See the guide <router-link to="/obyte-usdc-guide">How to get USDC into Obyte wallet to pay the contract</router-link> for details. You'll use this money to pay the contract amount.
        </div>
        <div class="col-lg-9 f-18 mt-4 color-2">
          6. Use <a href="https://getmein.ooo" target="_blank" rel="noopener">Get Me In</a> to transfer and convert a small (under $1 worth) amount of USDC to GBYTE in your Obyte wallet. You'll need this small amount of GBYTE to pay for transaction fees on Obyte, even if you are a seller. <!-- You can also acquire GBYTE on <a href="https://global.bittrex.com/trade/gbyte-btc" target="_blank" rel="noopener nofollow">Bittrex</a> and send the coins directly to your Obyte wallet. -->
        </div>
        <div class="col-lg-9 f-18 mt-4 color-2">
          7. Now you are ready to pay for contracts with arbitration.
        </div>
      </div>

      <div class="row">
        <h2 class="col-lg-9 f-52 ff-2 mt-5">
          Getting out
        </h2>
      </div>
      <div class="row">
        <div class="col-lg-9 f-18 mt-2 color-2">
          If you are a seller and have received stablecoins from a smart contract, you need to do the reverse operations to get fiat money: transfer the coins from Obyte to Ethereum using <a href="https://counterstake.org" target="_blank" rel="noopener">Counterstake Bridge</a>, then sell them for fiat on any cryptocurrency exchange (or OTC desk), and withdraw fiat to your bank account.
        </div>
        <div class="col-lg-9 f-18 mt-4 color-2">
          If you are both a buyer and a seller in different contracts (with suppliers and customers), you don't need to go to fiat all too often and can save on conversion costs.
        </div>
      </div>

      <div class="row">
        <h2 class="col-lg-9 f-52 ff-2 mt-5">
          Contact us for help
        </h2>
      </div>
      <div class="row">
        <div class="col-lg-9 f-18 mt-2 color-2">
          This process might seem complicated to those who are new to cryptocurrencies, feel free to reach out to us at <a href="mailto:support@arbstore.org">support@arbstore.org</a> and we'll be happy to provide additional guidance.
        </div>
      </div>

    </div>
  </main>
</template>
